import {MatPaginatorIntl} from '@angular/material';
export class MatPaginatorIntlVn extends MatPaginatorIntl {
  itemsPerPageLabel = 'Số dòng trên 1 trang';
  nextPageLabel     = 'Trang kế';
  previousPageLabel = 'Trang tiếp';
  firstPageLabel    = 'Trang đầu';
  lastPageLabel     = 'Trang cuối';
}